import { render, staticRenderFns } from "./cadre-program.component.vue?vue&type=template&id=538420f6&scoped=true&"
import script from "./cadre-program.component.ts?vue&type=script&lang=ts&"
export * from "./cadre-program.component.ts?vue&type=script&lang=ts&"
import style0 from "./cadre-program.component.scss?vue&type=style&index=0&id=538420f6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538420f6",
  null
  
)

export default component.exports